var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from 'vuex-class';
import { Dependencies } from '~/core/decorator';
import { MENU_CHANNEL } from "~/config/enum.config";
import { CaseOperatorPageService } from '~/services/domain-service/case-operator-page.service';
import { DataImportExcelInfoService } from '~/services/dataimp-service/data-import-excel-info.service.ts';
var CollectionExecutionModule = namespace('collection-execution');
var CaseCollectionState = /** @class */ (function (_super) {
    __extends(CaseCollectionState, _super);
    function CaseCollectionState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.caseInfo = {};
        return _this;
    }
    CaseCollectionState.prototype.onCaseIdChange = function () {
        this.refreshData();
    };
    Object.defineProperty(CaseCollectionState.prototype, "isTelShow", {
        get: function () {
            var _this = this;
            var arr = [MENU_CHANNEL.Tel_personal, MENU_CHANNEL.Tel_team, MENU_CHANNEL.Assist_tel];
            return arr.find(function (v) { return _this.menuChannel === v; });
        },
        enumerable: false,
        configurable: true
    });
    CaseCollectionState.prototype.mounted = function () {
        this.refreshData();
    };
    CaseCollectionState.prototype.refreshData = function () {
        var _this = this;
        if (this.menuChannel === MENU_CHANNEL.Case_imported) {
            this.dataImportExcelInfoService
                .getImportCaseInfo(this.caseId)
                .subscribe(function (data) { return (_this.caseInfo = data); });
        }
        else {
            this.caseOperatorPageService
                .queryCaseInfo(this.caseId)
                .subscribe(function (data) { return (_this.caseInfo = data); });
        }
    };
    CaseCollectionState.prototype.onClickEdit = function () {
        var _this = this;
        return this.$confirm('确认更改风险客户标识?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }).then(function () {
            _this.$emit('close');
            _this.caseOperatorPageService.modifyRiskFlag(_this.caseId).subscribe(function (data) {
                _this.$message.success('操作成功!');
                _this.refreshData();
            }, function (err) {
                _this.$message.success('操作失败!');
            });
        });
    };
    __decorate([
        Dependencies(CaseOperatorPageService)
    ], CaseCollectionState.prototype, "caseOperatorPageService", void 0);
    __decorate([
        Dependencies(DataImportExcelInfoService)
    ], CaseCollectionState.prototype, "dataImportExcelInfoService", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], CaseCollectionState.prototype, "caseId", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], CaseCollectionState.prototype, "menuChannel", void 0);
    __decorate([
        Watch("caseId")
    ], CaseCollectionState.prototype, "onCaseIdChange", null);
    CaseCollectionState = __decorate([
        Component
    ], CaseCollectionState);
    return CaseCollectionState;
}(Vue));
export default CaseCollectionState;
